import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampusEvent } from 'src/app/models/campus.model';
import { EventService } from 'src/app/services/event.service';
import { 
  IonProgressBar,
  IonList,
  IonLabel,
  IonItem,
  IonButton,
} from "@ionic/angular/standalone";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swiper from 'swiper';
import { AppService } from 'src/app/services/app.service';
import { Subscription } from 'rxjs';
import { register } from 'swiper/element/bundle';
import { EventImage } from 'src/app/models/event-image.model';

@Component({
  selector: 'app-local-event-detail',
  templateUrl: './local-event-detail.page.html',
  styleUrls: ['./local-event-detail.page.scss'],
  standalone: true,
  imports: [
        IonProgressBar,
        IonList,
        IonLabel,
        IonItem,
        IonButton,
        CommonModule,
        FormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LocalEventDetailPage {
  campusEvent?: CampusEvent;
  
  @ViewChild('swiper')
  swiperRef: ElementRef | undefined;

  swiperDoc: HTMLElement | null = document.getElementById('#thumbsSwiper');
  swiper?: Swiper;

  backSubscription?: Subscription

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected eventService: EventService,
    protected appService: AppService
  ) {
    register();
  }

  ionViewWillEnter() {
    this.route.paramMap.subscribe((data) => {
      const eventId = data.get('id');

      if (eventId) {
        this.getEventDetails(eventId);
      }
    });

    this.backSubscription = this.appService.backSubject.subscribe((_) => {
      this.router.navigateByUrl('/local-events');
    });
  }

  ionViewDidLeave() {
    if (this.backSubscription) {
      this.backSubscription.unsubscribe();
      this.backSubscription = undefined;
    }
  }

  getEventDetails(eventId: string) {
    this.eventService.getCampusEvent(eventId).subscribe(event => {
      this.campusEvent = event
    })
  }

  onThumbClick(picture: EventImage) {
    const index = this.campusEvent?.event?.image?.indexOf(picture);
    this.swiperRef?.nativeElement.swiper.slideTo(index);
  }

  visitEvent(): void {
    if (this.campusEvent?.event.url && this.campusEvent?.event.url != '') {
      window.open(this.campusEvent?.event.url, '_system')
    }
  }
}
